import { createLevelContext } from "../_lib/createLevelContext";

const { Provider, useValue } = createLevelContext("first");

export const FirstLevelProvider = Provider;
export const useFirstLevelContext = useValue;
